import { ComponentProps, ReactElement } from 'react';
import { getClasses, parsePhoneNumber } from '@/utils';

import InvoiceDetail from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetail';
import InvoicePdfAddress from '@/features/PdfLayout/layouts/Invoice/InvoicePdfAddress';
import InvoicePdfDetailList from '@/features/PdfLayout/layouts/Invoice/InvoicePdfDetailList';
import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoiceCompanyProps = ComponentProps<'ul'>;

const InvoiceCompany = ({ ...props }: InvoiceCompanyProps): ReactElement => {
  const { name, address, cityName, stateCode, zipCode, invoiceFax, invoicePhone, website, email, vendorNumber } = usePdfLayout(
    ({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
      // Company
      name: state?.data?.output?.company?.name,
      address: state?.data?.output?.company?.address,
      cityName: state?.data?.output?.company?.cityName,
      stateCode: state?.data?.output?.company?.stateCode,
      zipCode: state?.data?.output?.company?.zipCode,
      invoiceFax: state?.data?.output?.company?.invoiceFax,
      invoicePhone: state?.data?.output?.company?.invoicePhone,
      website: state?.data?.output?.company?.website,
      email: state?.data?.output?.company?.invoiceEmail,
      // Payer Provider
      vendorNumber: state?.data?.output?.payerProvider?.referenceNumber,
    })
  );

  return (
    <InvoicePdfDetailList {...props} className={getClasses('InvoicePdf-Company', props.className)}>
      {name && <InvoiceDetail>{name}</InvoiceDetail>}
      {vendorNumber && <InvoiceDetail name="Vendor Number">{vendorNumber}</InvoiceDetail>}
      <InvoicePdfAddress address={address} city={cityName} state={stateCode} zip={zipCode} country="United States" />
      {invoicePhone && <InvoiceDetail>{parsePhoneNumber(invoicePhone)} Accounting Dept.</InvoiceDetail>}
      {invoiceFax && <InvoiceDetail>{parsePhoneNumber(invoiceFax)} Fax</InvoiceDetail>}
      <InvoiceDetail bold name={email} />
      {website && <InvoiceDetail bold name={website} />}
    </InvoicePdfDetailList>
  );
};

export default InvoiceCompany;
